export default [
  // {
  //   path: "/logout",
  //   name: "logout",
  //   component: () => import("../views/logout.vue"),
  //   meta: {
  //     title: "Logout",
  //     isAuthPage: true,
  //   },
  // },
  // {
  //   path: "/",
  //   name: "home",
  //   component: () => import("../views/dashboard.vue"),
  //   meta: {
  //     title: "Dashboard",
  //     breadcrumbs: [],
  //   },
  // },
  {
    path: "/scheme-planning",
    name: "scheme-planning",
    uri: "/scheme-planning",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/scheme-planning/index.vue"
      ),
      meta: {
        title: "Scheme Planning",
        breadcrumbs: [],
        checkAuth: true,
      },
    children: [
      {
        path: "/scheme-planning/scheme",
        name: "scheme-create",
        uri: "/scheme-planning/scheme",
        component: () => import("../views/scheme-planning/create.vue"),
        meta: {
          title: "Create",
          breadcrumbs: [],
        },
        children: [],
      },
      {
        path: "/scheme-planning/scheme/:id",
        name: "schmen-create.id",
        uri: "/scheme-planning/scheme/id",
        component: () => import("../views/scheme-planning/create.vue"),
        meta: {
          title: "Edit",
          breadcrumbs: [],
        },
      },
    ],
  },
  {
    path: "/communication",
    name: "communication",
    uri: "/communication",
    component: () => import("../views/communication/index.vue"),
    meta: {
      title: "Communication",
      breadcrumbs: [],
      checkAuth: true,
    },
    children: [
      {
        path: "/",
        uri: "/communication",
        name: "communication",
        component: () => import("../views/communication/listing.vue"),
        meta: {
          title: "Communication",
          breadcrumbs: [],
          checkAuth: true,
        },
      },
      {
        path: "/communication/schedule",
        name: "communication-create",
        uri: "/communication/schedule",
        component: () => import("../views/communication/schedule.vue"),
        meta: {
          title: "Create Schedule",
          breadcrumbs: [],
        },
        children: [
          {
            path: ":id",
            name: "communication-create.id",
            uri: "/communication/schedule/id",
            component: () => import("../views/communication/schedule.vue"),
            meta: {
              title: "Create Schedule",
            },
            breadcrumbs: [],
          },
        ],
      },
    ],
  },
  {
    path: "/branch-budget",
    name: "branch-budget",
    uri: "/branch-budget",
    component: () => import("../views/branch-scheme/index.vue"),
    meta: {
      title: "Branch Budget",
      checkAuth: true,
    },
    children: [
      {
        path: "/",
        name: "branch-budget-listing",
        uri: "/branch-budget",
        component: () => import("../views/branch-scheme/listing.vue"),
        meta: {
          title: "Branch Budget",
        },
      },
      {
        path: "/branch-budget/branch",
        name: "branch-budget-create",
        uri: "/branch-budget/branch",
        component: () => import("../views/branch-scheme/create.vue"),
        meta: {
          title: "Create Branch Budget",
        },
        children: [],
      },
      {
        path: "/branch-budget/branch/:id",
        name: "branch-budget-create.id",
        uri: "/branch-budget/branch/id",
        component: () => import("../views/branch-scheme/create.vue"),
        meta: {
          title: "Edit Branch Budget",
        },
        children: [],
      },
    ],
  },
  {
    path: "/bulk-manual-payout-upload",
    name: "bulk-manual-payout-upload",
    uri: "/bulk-manual-payout-upload",
    component: () => import("../views/bulk-manual-payout-upload/index.vue"),
    meta: {
      title: "Bulk Manual Payout Upload",
      checkAuth: true,
    },
    children: [
      {
        path: "/",
        name: "bulk-manual-payout-upload-listing",
        uri: "/bulk-manual-payout-upload",
        component: () => import("../views/bulk-manual-payout-upload/listing.vue"),
        meta: {
          title: "Bulk Manual Payout Upload",
        },
      },
    ],
  },
  {
    path: "/trade-plan",
    name: "trade-plan",
    uri: "/trade-plan",
    component: () => import("../views/trade-plan/index.vue"),
    meta: {
      title: "Trade Plan",
      checkAuth: true,
    },
    children: [
      {
        path: "/",
        name: "trade-plan-listing",
        uri: "/trade-plan",
        component: () => import("../views/trade-plan/listing.vue"),
        meta: {
          title: "Trade Plan",
        },
      },
      {
        path: "/trade-plan/trade",
        name: "trade-plan-create",
        uri: "/trade-plan/trade",
        component: () => import("../views/trade-plan/create.vue"),
        meta: {
          title: "Create Trade Plan",
        },
        children: [
          {
            path: ":id",
            name: "trade-plan-create.id",
            uri: "/trade-plan/trade/id",
            component: () => import("../views/trade-plan/create.vue"),
            meta: {
              title: "Edit Trade Plan",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/masters/product/",
    name: "masters-product",
    component: () => import("../views/masters/product.vue"),
    meta: {
      title: "Create Product Group",
      checkAuth: true,
    },
  },
  {
    path: "/masters/emailGroup",
    name: "masters-emailGroup",
    component: () => import("../views/masters/emailGroup.vue"),
    meta: {
      title: "Email Group",
      checkAuth: true,
    },
  },
  {
    path: "/masters/journals",
    name: "masters-journals",
    component: () => import("../views/masters/journals.vue"),
    meta: {
      title: "Journals",
      checkAuth: true,
    },
  },
  {
    path: "/masters/configuration",
    name: "masters-configuration",
    component: () => import("../views/configuration/index.vue"),
    meta: {
      title: "Configuration",
      checkAuth: true,
    },
  },
  {
    path: "/masters/hierarchy-setup",
    name: "masters-hierarchySetup",
    component: () => import("../views/masters/hierarchy.vue"),
    meta: {
      title: "Hierarchy Setup",
      checkAuth: true,
    },
  },
  {
    path: "/masters/target-planning",
    name: "masters-targetJournals",
    component: () => import("../views/masters/target-planning.vue"),
    meta: {
      title: "Target Journals",
    },
  },
  {
    path: "/masters/target-deployment",
    name: "masters-targetDeployment",
    component: () => import("../views/masters/target-deployment.vue"),
    meta: {
      title: "Target Deployment",
    },
  },
  {
    path: "/masters/campaign-management",
    name: "masters-campaignManagement",
    component: () => import("../views/masters/campaign-management.vue"),
    meta: {
      title: "Campaign Management",
    },
  },
  {
    path: "/masters/customer-master",
    name: "masters-customerMaster",
    component: () => import("../views/masters/customer-master.vue"),
    meta: {
      title: "Customer Master",
    },
  },

  // {
  //   path: "/unauthorized",
  //   name: "unauthorized",
  //   uri: "/unauthorized",
  //   component: () => import("../views/unAuthorized.vue"),
  //   meta: {
  //     title: "Unauthorized",
  //   },
  // },
  {
    path: "/approval/request/:type/:revisionId/:planId/",
    name: "approval-workflowReview",
    component: () => import("../views/workflow/index.vue"),
    meta: {
      title: "Review Workflow Request",
    },
  },
  {
    path: "/approval/enquiry/:requestId",
    name: "approval-workflowEnquiry",
    component: () => import("../views/workflow/enquiry.vue"),
    meta: {
      title: "Enquiry Workflow Request",
    },
  },
  {
    path: "/reports/payout",
    name: "reports.payout",
    uri: "/reports/payout",
    component: () => import("../components/Report/payout.vue"),
    meta: {
      title: "Payout Reports",
    },
  },
  {
    path: "/reports/schemeCriteria",
    name: "reports.schemeCriteria",
    uri: "/reports/schemeCriteria",
    component: () => import("../components/Report/schemeCriteria.vue"),
    meta: {
      title: "Scheme Criteria Reports",
    },
  },
  {
    path: "/reports/imeiLedgerReport",
    name: "reports.imeiLedgerReport",
    uri: "/reports/imeiLedgerReport",
    component: () => import("../components/Report/imeiLedgerReport.vue"),
    meta: {
      title: "IMEI/Serial Wise Payout Reports",
    },
  },
  {
    path: "/reports/communication",
    name: "reports.communication",
    uri: "/reports/communication",
    component: () => import("../components/Report/communicationLog.vue"),
    meta: {
      title: "Communication Reports",
    },
  },
  {
    path: "/reports/doaReport",
    name: "reports.doaReport",
    uri: "/reports/doaReport",
    component: () => import("../components/Report/doaReport.vue"),
    meta: {
      title: "DOA Reports",
    },
  },
  {
    path: "/reports/nerpReport",
    name: "reports.nerpReport",
    uri: "/reports/nerpReport",
    component: () => import("../components/Report/nerpReport.vue"),
    meta: {
      title: "NERP Reports",
    },
  },
  // {
  //   path: "/404",
  //   name: "notFound",
  //   component: () => import("../views/unAuthorized.vue"),
  //   meta: {
  //     title: "Not Found",
  //   },
  // },
  {
    path: "/accrual",
    name: "accrual",
    uri: "/accrual",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Accrual/index.vue"),
    meta: {
      title: "accrual",
      checkAuth: true,
    },
    children: [
      {
        path: "/",
        name: "accrual-listing",
        uri: "/accrual",
        component: () => import("../views/Accrual/AccrualList.vue"),
        meta: {
          // title: "accrual listing",
          checkAuth: true,
        },
      },
      {
        path: "/accrual/definition",
        name: "Accrual definition",
        uri: "/accrual/definition",
        component: () => import("../views/Accrual/AccrualDefinition.vue"),
        meta: {
          title: "Accrual definition",
        },
        children: [
          {
            path: ":id",
            name: "accrual-create.id",
            uri: "/accrual/definition/id",
            component: () => import("../views/Accrual/AccrualDefinition.vue"),
            meta: {
              title: "Accrual definition",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/payout",
    name: "payout",
    uri: "/payout",
    component: () => import("../views/payout/index.vue"),
    meta: {
      title: "Payout",
      breadcrumbs: [],
      checkAuth: true,
    },
  },

  {
    path: "/masters",
    name: "masters",
    uri: "/masters",
    component: () => import("../views/masters/index.vue"),
    meta: {
      // title: "Masters",
      checkAuth: true,
    },
    children: [
      {
        path: "/masters/partner",
        name: "masters-partner",
        component: () => import("../views/masters/partner.vue"),
        meta: {
          title: "Create Partner Group",
          checkAuth: true,
        },
      },
      {
        path: "/masters/product/",
        name: "masters-product",
        component: () => import("../views/masters/product.vue"),
        meta: {
          title: "Create Product Group",
          checkAuth: true,
        },
      },
      {
        path: "/masters/emailGroup",
        name: "masters-emailGroup",
        component: () => import("../views/masters/emailGroup.vue"),
        meta: {
          title: "Email Group",
          checkAuth: true,
        },
      },
      {
        path: "/masters/journals",
        name: "masters-journals",
        component: () => import("../views/masters/journals.vue"),
        meta: {
          title: "Journals",
          checkAuth: true,
        },
      },
      {
        path: "/masters/configuration",
        name: "masters-configuration",
        component: () => import("../views/configuration/index.vue"),
        meta: {
          title: "Configuration",
          checkAuth: true,
        },
      },
      {
        path: "/masters/hierarchy-setup",
        name: "masters-hierarchySetup",
        component: () => import("../views/masters/hierarchy.vue"),
        meta: {
          title: "Hierarchy Setup",
          checkAuth: true,
        },
      },
      {
        path: "/masters/target-planning",
        name: "masters-targetJournals",
        component: () => import("../views/masters/target-planning.vue"),
        meta: {
          title: "Target Journals",
        },
      },
    ],
  },

  // {
  //   path: "/unauthorized",
  //   name: "unauthorized",
  //   uri: "/unauthorized",
  //   component: () => import("../views/unAuthorized.vue"),
  //   meta: {
  //     title: "Unauthorized",
  //   },
  // },
  {
    path: "/workflow/approval/request/communication/:scheduleId/",
    name: "workflow-communicationWorkflowApproval",
    component: () => import("../views/communication/workflow/index.vue"),
    meta: {
      title: "Review Workflow Request",
    },
  },
  {
    path: "/approval/enquiry/:requestId",
    name: "workflowEnquiry",
    component: () => import("../views/workflow/enquiry.vue"),
    meta: {
      title: "Enquiry Workflow Request",
    },
  },
  // {
  //   path: "/404",
  //   name: "notFound",
  //   component: () => import("../views/unAuthorized.vue"),
  //   meta: {
  //     title: "Not Found",
  //   },
  // },
];
